export default `Region,Population
Abruzzo,1311580
Aosta Valley,125666
Apulia,4029053
Basilicata,562869
Calabria,1947131
Campania,5801692
Emilia-Romagna,4459477
Friuli Venezia Giulia,1215220
Lazio,5879082
Liguria,1550640
Lombardy,10060574
Marche,1525271
Molise,305617
Piedmont,4356406
Sardinia,1639591
Sicily,4999891
Trentino-South Tyrol,1072276
Tuscany,3729641
Umbria,882015
Veneto,4905854`